<template>
  <el-popover
    v-model="visible"
    placement="top-start"
    width="288"
    trigger="click"
    popper-class="find-sound-admin-emoji-popover"
    :visible-arrow="false"
  >
    <div class="find-sound-admin-emoji-picker" aria-label="选择表情">
      <div class="find-sound-admin-emoji-picker__title">常用表情</div>
      <button
        v-for="emoji in emojis"
        :key="emoji"
        type="button"
        class="find-sound-admin-emoji-picker__item"
        :title="`插入 ${emoji}`"
        @click="selectEmoji(emoji)"
      >
        {{ emoji }}
      </button>
    </div>
    <el-button
      slot="reference"
      class="find-sound-admin-emoji-trigger"
      size="mini"
      type="text"
      title="选择表情"
      aria-label="选择表情"
    >
      😊
    </el-button>
  </el-popover>
</template>

<script>
// 直接使用系统 Emoji，不新增图片资源或第三方依赖，后台离线环境也能正常选择。
const COMMON_EMOJIS = [
  "😀", "😄", "😁", "😂", "😊", "😍", "🥰", "😎", "🤔", "😅",
  "😭", "😡", "👍", "👎", "👏", "🙏", "💪", "🎉", "❤️", "🔥",
  "✨", "✅", "❓", "🎵", "🎧", "🔊", "🎤", "🎬", "💡", "📎",
];

export default {
  name: "FindSoundAdminEmojiPicker",
  data() {
    return {
      visible: false,
      emojis: COMMON_EMOJIS,
    };
  },
  methods: {
    /**
     * 把选中的 Emoji 交给回复输入框，由父页面按当前光标位置插入。
     *
     * @example 点击“😊”时触发 select("😊")，面板保持打开以便连续选择。
     */
    selectEmoji(emoji) {
      this.$emit("select", emoji);
    },
  },
};
</script>

<style lang="scss">
.find-sound-admin-emoji-popover {
  padding: 12px;
  .find-sound-admin-emoji-picker {
    display: flex;
    flex-wrap: wrap;
  }
  .find-sound-admin-emoji-picker__title {
    width: 100%;
    margin-bottom: 8px;
    color: #909399;
    font-size: 12px;
  }
  .find-sound-admin-emoji-picker__item {
    width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    font-size: 20px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
  .find-sound-admin-emoji-picker__item:hover {
    background: #f2f6fc;
  }
}

.find-sound-admin-emoji-trigger.el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 24px;
  min-width: 30px;
  padding: 0 !important;
  font-family: "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
  font-size: 18px !important;
  line-height: 1 !important;
  vertical-align: middle;
}

.find-sound-admin-emoji-trigger.el-button > span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  line-height: 1;
}
</style>
